/**
 * Vroom Vroom Dismissable Banner Alpine.js Component
 *
 * Drives the "have you booked your stay?" banner shown at the top of the
 * Parkway shuttle landing and schedule pages. Once a visitor closes it, the
 * dismissal persists across visits (and across both pages) via localStorage.
 */
const STORAGE_KEY = 'vv-parkway-banner-dismissed';

export default function vroomvroomBanner() {
    return {
        visible: false,

        init() {
            this.visible = !this.isDismissed();
            this.initPageShowResync();
        },

        dismiss() {
            this.visible = false;
            try {
                window.localStorage.setItem(STORAGE_KEY, '1');
            } catch (e) {
                // localStorage unavailable (private mode / quota) — the banner
                // simply won't persist its dismissal, which is acceptable.
            }
        },

        isDismissed() {
            try {
                return window.localStorage.getItem(STORAGE_KEY) === '1';
            } catch (e) {
                return false;
            }
        },

        // Safari bfcache: x-show bindings are not re-evaluated when the page is
        // restored via back/forward. Re-sync against the persisted state, but
        // only force a re-render when it actually changed (e.g. dismissed in
        // another tab) — otherwise we'd flicker the banner for visitors who
        // never dismissed it.
        initPageShowResync() {
            window.addEventListener('pageshow', (event) => {
                if (!event.persisted) return;

                const shouldBeVisible = !this.isDismissed();
                if (this.visible === shouldBeVisible) return;

                this.visible = false;
                this.$nextTick(() => {
                    this.visible = shouldBeVisible;
                });
            });
        },
    };
}
